import { useMutation } from "react-query";
import api from "../../client";
import { Checklist } from "../../types/checklist";

const deleteData = async (id: string | undefined): Promise<Checklist> => {
  const { data } = await api.delete(`/checklists/${id}`);

  return data;
};

export const useDeleteChecklist = () => {
  return useMutation((id: string | undefined) => {
    return deleteData(id);
  });
};
